import { ApiResponse } from '@core/models/api.model';
import {
  ApiCredential,
  ApiEndpoint,
  ApiSettingsData,
} from '@features/api-settings/api-settings.model';

const MOCK_CREDENTIAL: ApiCredential = {
  app_id: '0000175a370efbbe852dc1cd1b0b877e',
  app_token: 'a844e832****************************',
  app_key: '********************************',
  environment: 'production',
  connection_status: 'stable',
  last_checked: new Date(Date.now() - 2 * 60 * 1000).toISOString(), // 2 phút trước
};

const MOCK_ENDPOINTS: ApiEndpoint[] = [
  {
    id: 1,
    name: 'User Login',
    code: 'thirdCustLogin',
    method: 'POST',
    endpoint: '/openapi/custCloud/app/user/thirdCustLogin',
    rate_limit: null,
    status: 1,
  },
  {
    id: 2,
    name: 'Device Info',
    code: 'devInfo',
    method: 'POST',
    endpoint: '/openapi/custCloud/oss/devInfo',
    rate_limit: '10/s',
    status: 1,
  },
  {
    id: 3,
    name: 'Device List',
    code: 'devList',
    method: 'POST',
    endpoint: '/openapi/custCloud/oss/devList',
    rate_limit: '10/s',
    status: 1,
  },
  {
    id: 4,
    name: 'Device Control',
    code: 'devCtrl',
    method: 'POST',
    endpoint: '/openapi/custCloud/oss/devCtrl',
    rate_limit: '5/s',
    status: 1,
  },
  {
    id: 5,
    name: 'Cloud Storage Status',
    code: 'cloudStatus',
    method: 'GET',
    endpoint: '/openapi/custCloud/oss/cloudStatus',
    rate_limit: '20/s',
    status: 1,
  },
  {
    id: 6,
    name: 'Push Notification',
    code: 'pushNotify',
    method: 'POST',
    endpoint: '/openapi/custCloud/app/pushNotify',
    rate_limit: '50/s',
    status: 0,
  },
];

export const API_SETTINGS_MOCK = {
  getData: (): ApiResponse<ApiSettingsData> => ({
    status: true,
    mess: 'Success',
    data: {
      credential: { ...MOCK_CREDENTIAL },
      endpoints: [...MOCK_ENDPOINTS],
    },
  }),

  checkConnection: () => ({
    status: true,
    mess: 'Success',
    data: {
      connection_status: 'stable' as const,
      last_checked: new Date().toISOString(),
      latency_ms: 42,
    },
  }),

  successResponse: (mess: string) => ({
    status: true,
    mess,
    data: null,
  }),
};
